export default __webpack_public_path__ + "static/media/img5.1a2aa2f9.png";